<script>
import fields from '@/components/fields/'
import BaseWidgetForm from "./BaseWidgetForm";

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        ...this.getCommonFields(),
        {
          label: 'Ogólne',
          fields: [
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              required: true,
            }),
            new fields.WYSIWYG({
              label: 'Tekst',
              required: true,
              modelPath: [this, 'form', 'text'],
              type: 'emptyMenuBarInit'
            }),
            new fields.Image({
              label: 'Zdjęcie',
              modelPath: [this, 'form', 'image'],
              required: true,
            }),
            new fields.Link({
              labelPlaceholder: 'Tekst buttona',
              label: 'Button',
              required: false,
              modelPath: [this, 'form', 'button']
            }),
          ]
        }
      ]
    }
  }
}
</script>
